// Defaults

export const MAX_CHARACTER_LENGTH = 255;
export const MAX_PASSWORD_LENGTH = 40;
export const MIN_PASSWORD_LENGTH = 7;
const ON_CHANGE_TIMEOUT_DELAY = 3000;

// Default field types

export const TEXT = 'text';
export const SELECT = 'select';

export const NAME = 'name';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const EMAIL = 'email';
export const PHONE = 'phone';
export const PHONE_TYPE = 'phoneType';
export const ADDRESS = 'address';
export const ADDRESS_LINE_1 = 'addressLine1';
export const ADDRESS_LINE_2 = 'addressLine2';
export const COUNTRY = 'country';
export const ZIP = 'zip';
export const CITY = 'city';
export const STATE = 'state';
export const PASSWORD = 'password';
export const CREDIT_CARD = 'creditCard';

// Validation keys
export const REQUIRE_AT = 'requireAt';
export const REQUIRE_TOP_LEVEL_DOMAIN = 'requireTopLevelDomain';
export const REQUIRE_DOMAIN_NAME = 'requireDomainName';
export const REQUIRE_VALID_DOMAIN = 'requireValidDomain';
export const NOT_EMPTY = 'notEmpty';
export const MAX_LENGTH = 'maxLength';
export const HAS_INVALID_SPECIAL_CHARACTER_ON_ADDRESS =
  'hasInvalidSpecialCharacterOnAddress';
export const HAS_INVALID_SPECIAL_CHARACTER_ON_EMAIL =
  'hasInvalidSpecialCharacterOnEmail';
export const AT_LEAST_ONE_NUMERIC = 'atLeastOneNumeric';
export const IS_MATCHING_ZIP_TO_STATE = 'isMatchingZipToState';
export const IS_MATCHING_ZIP_TO_COUNTRY = 'isMatchingZipToCountry';
export const IS_VALID_NAME = 'isValidName';
export const IS_VALID_EMAIL = 'isValidEmail';
export const IS_VALID_PHONE = 'isValidPhone';
export const IS_VALID_PHONE_NUMBER_LENGTH = 'isValidPhoneNumberLength';
export const IS_VALID_ADDRESS = 'isValidAddress';
export const IS_VALID_POSTAL_CODE = 'isValidPostalCode';
export const IS_VALID_PASSWORD = 'isValidPassword';
export const IS_VALID_AMEX_CREDIT_CARD_LENGTH = 'isValidAmexCreditCardLength';
export const IS_VALID_CREDIT_CARD = 'isValidCreditCard';
export const IS_VALID_CREDIT_CARD_LENGTH = 'isValidCreditCardLength';

// Field condition

export const PRISTINE = 'pristine';
export const DIRTY = 'dirty';

// Default field states

export const defaultErrorState = {
  failedValidations: [],
  hasErrors: false,
  isPendingValidation: false,
  message: ''
};

export const defaultFieldState = {
  condition: PRISTINE,
  delayTime: ON_CHANGE_TIMEOUT_DELAY,
  error: defaultErrorState,
  isRequired: true,
  name: '',
  validateOnChange: false,
  validateWithTimeout: false,
  validations: [],
  value: ''
};

export const CARD_LENGTHS = {
  AMEX: 15,
  NON_AMEX: 16
};
